<template>
  <div class="hzc-industry-dynamics no-li">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/macroscopic')">政策法规</span> > <span
        @click="back('/macroscopic/twoPage/industry', flag)"
        style="cursor: pointer">{{ flag === '8' ? '宏观' : flag === '9' ? '黑色' : flag === '10' ? '化工' : '环保' }}</span> > 正文
    </div>
    <div class="content">
      <div class="top">
        <p>{{ row.titleName }}</p>
        <span>发布时间：{{ row.showYearTime }}</span><span>来源：{{ row.updateBy || "网络" }}</span>
      </div>
      <div class="bom" v-html="row.newsContent"></div>
    </div>
  </div>
</template>

<script>
import {
  industryDetail,
} from '@/api/macroscopic'

export default {
  data() {
    return {
      row: {},
      page: 1,
      size: 15,
      total: 0,
      title: '',
      flag: '8'
    }
  },
  created() {
    if (this.$route.query.flag) {
      this.flag = this.$route.query.flag;
      console.log(this.flag)
    }
    this.getIndustry(this.$route.query.id);
  },
  methods: {
    // 行业动态
    getIndustry(pageParams) {
      industryDetail(pageParams).then(res => {
        this.row = res.data;
      })
    },
    back(url, flag) {
      this.$router.push({path: url, query:{flag}});
    },
  }
}
</script>

<style scoped lang="less">
.hzc-industry-dynamics {
  width: 1200px;
  margin: 0 auto;

  .content {
    width: 960px;
    min-height: 500px;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    margin: 16px auto 0;

    .top {

      border-bottom: 1px solid #ccc;
      padding: 16px 0;
      text-align: center;

      p {
        color: #222;
        font-size: 24px;
      }

      span {
        display: inline-block;
        margin-right: 16px;
        color: #777777;
        font-size: 12px;
      }
    }

    .bom {
      padding: 16px 40px;
      ::v-deep {
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
